import React from "react";

import { formatDateLocalTZ } from "utils/utils.js";
import { InsightsStrings } from "constants/constantStrings";
import { DATE_FORMAT_WITH_BITWISEOR } from "constants/globalConstants";

import TooltipLabelWithEllipsis from "components/TooltipLabelWithEllipsis/index.js";

import "./index.scss";

const InsightCard = ({ value }) => {
  const getTagId = value => {
    const tagId = value.AnomalyType === InsightsStrings.FIT1 ? InsightsStrings.feedTag : InsightsStrings.brineTag;
    value.tagId = tagId;
    return tagId;
  };

  const getLabel = () => {
    const label = value.AnomalyType === InsightsStrings.FIT1 ? InsightsStrings.feedFlow : InsightsStrings.brineFlow;
    value.label = label;
    return label;
  };

  return (
    <div className="cardContainer insight-card">
      <div className="flex-between marginBtm10 ">
        <div>
          <div className="dupont-form-label">{getLabel()}</div>
          <div className="bodySecondaryHeadingText marginTop5">{getTagId(value)}</div>
          <div className="smalldescriptionGreyText marginTop5">
            {InsightsStrings.start}
            {formatDateLocalTZ(value.CycleStartTime, DATE_FORMAT_WITH_BITWISEOR)}
          </div>
          <div className="smalldescriptionGreyText">
            {InsightsStrings.end}
            {formatDateLocalTZ(value.CycleEndTime, DATE_FORMAT_WITH_BITWISEOR)}
          </div>
        </div>
      </div>
      <TooltipLabelWithEllipsis label={value.SystemName} />
      <TooltipLabelWithEllipsis
        label={value.AnomalyType === InsightsStrings.FIT1 ? InsightsStrings.insightfeed : InsightsStrings.insightBrine}
        customClass="bodySecondaryHeadingText max_two_line"
        multiline
      />
    </div>
  );
};

export default InsightCard;
